import Button from "components/base/button/Button";
import { MdOutlineDoNotDisturb } from "react-icons/md";
import { useAuth } from "hooks‬/Auth";

const NotAuthorized = () => {
  const { systemLogout } = useAuth();
  return (
    <div className="m-auto mt-10">
      <div className="text-center my-10">
        <MdOutlineDoNotDisturb
          className="text-danger"
          style={{ fontSize: "100px" }}
        />
      </div>
      <h1 className="text-center mt-5">
        You are not authorized to login here.
      </h1>

      <div className="text-center mt-10">
        <Button type="button" onClick={() => systemLogout()}>
          Go to Login Page
        </Button>
      </div>
    </div>
  );
};

export default NotAuthorized;
